module.exports = __webpack_public_path__ + "img/server-2.66a3ed56.webp";